// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1KP_N","col":"styles_col__1nW1V"};